import React, { useEffect, useMemo, useState } from "react";

import {
  LinkSimple,
  Plus,
} from "@phosphor-icons/react";

import ActaModal from "@/components/ui/ActaModal";


function accessoryLabel(accessory) {
  return [
    accessory.name,
    accessory.serialNumber,
  ]
    .filter(Boolean)
    .join(" — ");
}


export default function MachineAccessoryLinkModal({
  open,
  machine,
  accessories = [],
  saving = false,
  onClose,
  onLink,
  onCreate,
}) {
  const [selectedId, setSelectedId] =
    useState("");

  useEffect(() => {
    if (open) {
      setSelectedId("");
    }
  }, [open]);


  const availableAccessories =
    useMemo(
      () =>
        accessories
          .filter(
            (item) =>
              item &&
              item.isArchived !== true &&
              item.equipmentType ===
                "accessory" &&
              !item.parentMachineId &&
              (
                !machine?.prospectId ||
                !item.prospectId ||
                item.prospectId ===
                  machine.prospectId
              )
          )
          .sort(
            (left, right) =>
              accessoryLabel(
                left
              ).localeCompare(
                accessoryLabel(
                  right
                ),
                "fr",
                {
                  sensitivity:
                    "base",
                }
              )
          ),
      [
        accessories,
        machine?.prospectId,
      ]
    );


  if (!open || !machine) {
    return null;
  }


  return (
    <ActaModal
      open={open}
      onClose={onClose}
      eyebrow="GMAO"
      title="Ajouter un accessoire"
      subtitle={
        `Rattachez un accessoire existant à ${machine.name} ou créez-en un nouveau.`
      }
      size="md"
      closeDisabled={saving}
      testId="machine-accessory-link-modal"
    >
      <div className="space-y-5">
        <section>
          <label
            htmlFor="machine-accessory-existing"
            className="label-eyebrow mb-1.5 block"
          >
            Accessoire existant
          </label>

          <select
            id="machine-accessory-existing"
            value={selectedId}
            onChange={(event) =>
              setSelectedId(
                event.target.value
              )
            }
            disabled={
              saving ||
              availableAccessories.length ===
                0
            }
            className="w-full rounded-lg border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-3 py-2.5 text-sm outline-none focus:border-[var(--do-accent)] disabled:opacity-60"
            data-testid="machine-accessory-existing-select"
          >
            <option value="">
              {availableAccessories.length
                ? "Sélectionner un accessoire"
                : "Aucun accessoire disponible"}
            </option>

            {availableAccessories.map(
              (accessory) => (
                <option
                  key={accessory.id}
                  value={accessory.id}
                >
                  {accessoryLabel(
                    accessory
                  )}
                </option>
              )
            )}
          </select>

          <button
            type="button"
            onClick={() =>
              onLink(selectedId)
            }
            disabled={
              saving ||
              !selectedId
            }
            className="mt-3 inline-flex items-center gap-2 rounded-lg bg-[var(--do-accent)] px-4 py-2.5 text-sm font-heading font-bold text-[var(--do-on-accent)] disabled:opacity-50"
            data-testid="machine-accessory-link-submit"
          >
            <LinkSimple
              size={17}
              weight="bold"
            />
            Rattacher l'accessoire
          </button>
        </section>

        <div className="border-t border-[var(--do-border)] pt-5">
          <div className="text-sm font-heading font-bold">
            Nouvel accessoire
          </div>

          <p className="mt-1 text-xs text-[var(--do-muted)]">
            Créez un accessoire sérialisé depuis le catalogue puis rattachez-le automatiquement à cette machine.
          </p>

          <button
            type="button"
            onClick={onCreate}
            disabled={saving}
            className="mt-3 inline-flex items-center gap-2 rounded-lg border border-[var(--do-border)] bg-[var(--do-bg-solid)] px-4 py-2.5 text-sm font-heading font-bold hover:bg-[var(--do-surface-soft)] disabled:opacity-50"
            data-testid="machine-accessory-create"
          >
            <Plus
              size={17}
              weight="bold"
            />
            Créer un accessoire
          </button>
        </div>
      </div>
    </ActaModal>
  );
}
